module.exports = __webpack_public_path__ + "img/Saint Kitts and Nevis.2509e6b6.svg";